import * as XLSX from "xlsx";

import type { InteractionProps } from "./interfaces";
import {
  getMeetingDataCellExportText,
  MEETING_TABLE_COLUMN_SPECS,
} from "./interactionsTableCells";

export function downloadInteractionsExcel(
  docs: InteractionProps[],
  filenameBase = "interacoes",
): void {
  const specs = MEETING_TABLE_COLUMN_SPECS;
  const headers = specs.map((c) => c.headerName);
  const rows = docs.map((doc) =>
    specs.map((spec) => getMeetingDataCellExportText(spec.field, doc)),
  );
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Interações");
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${filenameBase}_${stamp}.xlsx`);
}
